/**
 * Route wrapper for the connection callback.
 *
 * The handoff's deployment gate: the catalogue and its REST routes exist only
 * when the backend CDK context value `integrations_enabled` is Boolean `true`.
 * `REACT_APP_INTEGRATIONS_ENABLED` is this app's switch for that.
 *
 * The catalogue itself is mounted by the existing Integrations screen
 * (`components/api/APIIntegrationsView`), as a tab beside the native dashboard.
 * Only the callback needs a route of its own — a provider redirect has to land
 * on a real URL — and with the flag off there is nothing for it to complete, so
 * it sends the user to the Integrations screen instead.
 */

import { Navigate } from "react-router-dom";
import { INTEGRATIONS_ENABLED } from "core/features/integrations/config";
import { ConnectCallback } from "./ConnectCallback";

export function IntegrationsCallbackRoute() {
    if (!INTEGRATIONS_ENABLED) return <Navigate to="/integrations" replace />;
    return <ConnectCallback />;
}

export default IntegrationsCallbackRoute;
